document.addEventListener('DOMContentLoaded', function() {
  function setupFlip(cardId, flipBtnId, flipBtnBackId) {
    const card = document.getElementById(cardId);
    const flipButton = document.getElementById(flipBtnId);
    const flipButtonBack = document.getElementById(flipBtnBackId);

    // Sprawdź, czy elementy istnieją
    if (card && flipButton && flipButtonBack) {
      function toggleFlip() {
        card.classList.toggle('flipped');
      }

      flipButton.addEventListener('click', toggleFlip);
      flipButtonBack.addEventListener('click', toggleFlip);
    }
  }

  // Ustawiamy dla każdej karty, jeśli elementy istnieją
  setupFlip('card1', 'flipButton1', 'flipButtonBack1');
  setupFlip('card2', 'flipButton2', 'flipButtonBack2');
});
